import Service from '@ember/service';

import ENV from 'rise-ui/config/environment.js';
import { ajax } from 'rise-ui/utils/ajax-rise.js';

const groupBlacklist = [ 'stateId' ];

/**
 * Queries/serializes location-filters for time-series routes
 * @name LocationFiltersModelService
 */
export default class LocationFiltersModelService extends Service {
  async fetch(queryParams, headers = {}) {
    const API = ENV.APP.API.DATA;
    const url = [ API.URL , API.NAMESPACE , 'location-filter' ];
    return this.serializeMany(await ajax.get(url, {
      headers,
      queryParams,
    }));
  }

  serializeMany(response) {
    const result = [];
    if (response && response.data && response.data.length) {
      response.data.forEach(model => {
        result.push(this.serialize(model));
      });
    }
    return result;
  }

  serialize(model) {
    const attr = model.attributes || {};
    return {
      id:      model.id,
      array:   attr.array,
      key:     attr.key,
      label:   attr.label,
      options: attr.options?.map(v => {
        v.value = String(v.value);
        return v;
      }),
      group:   !groupBlacklist.includes(attr.key),
    };
  }
}
